// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wt_a big_b big_we"};